import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, MOCKUP_IMG, REGULAR_PRICE, TODAY_PRICE } from '../data/product';
export function PricingCard() {
  return <section id="pricing" className="bg-ink text-white px-4 sm:px-6 py-9 sm:py-12 scroll-mt-4" data-id="element-120" data-mp="1m52r0zwd6v6h">
      <div className="max-w-2xl mx-auto text-center" data-id="element-121" data-mp="1i4ahe5jkyo9o">
        <h2 className="font-heading font-extrabold uppercase text-lg sm:text-2xl leading-tight tracking-tight mb-5" data-id="element-122" data-mp="2eti4hhzul5fp">
          Everything included.{' '}
          <span className="text-lime" data-id="element-123" data-mp="29unkicq59au0">One simple price.</span>
        </h2>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-5" data-id="element-124" data-mp="251ui3vi5eel3">
          <img src={MOCKUP_IMG} alt="Fitness Senior Ready 6-in-1 system with all six modules and five bonuses" className="w-full max-w-[240px] sm:max-w-sm mx-auto object-contain hover:scale-[1.01] transition-transform duration-300 ease-out" data-id="element-125" data-mp="2xj7za53m1r7m" />
        </a>

        <div className="bg-white/[0.05] border-2 border-lime/40 rounded-xl p-5 sm:p-7 max-w-sm mx-auto" data-id="element-126" data-mp="37j5koj84lp8c">
          <h3 className="font-heading font-extrabold uppercase text-base sm:text-xl tracking-tight mb-1.5" data-id="element-127" data-mp="2sv2ilkx7exot">
            Fitness Senior Ready™
          </h3>
          <p className="text-[11px] sm:text-sm text-white/60 leading-snug mb-4" data-id="element-128" data-mp="2xrj4e8gxkzyq">
            Complete 6-in-1 Senior Fitness Coaching System + 5 Premium Bonuses
          </p>

          <p className="text-[11px] sm:text-sm font-semibold text-white/50 mb-0.5" data-id="element-129" data-mp="2otpd5by0wwif">
            Regular Price: <span className="line-through" data-id="element-130" data-mp="29x7z2cyg93s6">{REGULAR_PRICE}</span>
          </p>

          <p className="font-heading font-bold text-[9px] sm:text-[11px] uppercase tracking-[0.16em] text-lime" data-id="element-131" data-mp="2evt0gfpftti7">
            Today:
          </p>
          <p className="font-heading font-black text-3xl sm:text-5xl text-white leading-none mb-2" data-id="element-132" data-mp="827b5ionxrvn">
            {TODAY_PRICE}
          </p>

          <p className="inline-block font-heading font-bold text-[10px] uppercase tracking-[0.12em] text-ink bg-gold rounded px-2.5 py-1 mb-4" data-id="element-133" data-mp="bmr39890fovs">
            Save $54.10
          </p>

          <ul className="flex flex-col gap-1.5 text-left mb-4 pt-4 border-t border-white/10" data-id="element-134" data-mp="1ns188ir2rhr">
            <li className="flex items-center gap-2 font-heading font-bold uppercase text-[10px] sm:text-xs tracking-wide" data-id="element-135" data-mp="3trud169x8p2j">
              <CheckIcon className="w-3.5 h-3.5 text-lime shrink-0" data-id="element-136" data-mp="ucz0j9q13l42" />
              One-time payment
            </li>
            <li className="flex items-center gap-2 font-heading font-bold uppercase text-[10px] sm:text-xs tracking-wide" data-id="element-137" data-mp="pexhgoslrlsl">
              <CheckIcon className="w-3.5 h-3.5 text-lime shrink-0" data-id="element-138" data-mp="kl32tzrutx0d" />
              Lifetime access
            </li>
          </ul>

          <CTAButton href={CHECKOUT_URL} data-id="element-139" data-mp="1d3705huirtfi">
            Get Fitness Senior Ready™ Now
          </CTAButton>

          <p className="text-[10px] sm:text-xs font-semibold text-white/50 mt-2.5 tracking-wide" data-id="element-140" data-mp="18cqj7nrhppoe">
            Instant Digital Access · Secure Payment · 7-Day Guarantee
          </p>
        </div>
      </div>
    </section>;
}